import React, { useState } from 'react';
import AndroidPackagePanel from './AndroidPackagePanel';
import IosAppPanel from './IosAppPanel';
import DesktopPackagePanel from './DesktopPackagePanel';
import AppStartPanel from './AppStartPanel';
import { previewPageUrl, withoutOwnerKey } from './PreviewFrame';
import './ChatNextSteps.css';

export const PUBLISH_REQUEST_TEXT = 'פרסם את האתר לחשבון שלי';

// Universal Desktop (Windows + Linux + macOS) for desktop projects and finished websites.
export function canPackageDesktop(target) {
  return ['DESKTOP', 'WEB'].includes(String(target || 'WEB').toUpperCase());
}

export function iphoneHomeScreenSteps() {
  return [
    'פתחו את קישור האתר בדפדפן Safari באייפון.',
    'לחצו על כפתור השיתוף (ריבוע עם חץ למעלה).',
    'בחרו "הוסף למסך הבית" ואשרו.'
  ];
}

/**
 * "What now?" card under the latest verified Preview. Everything here starts only after the
 * website Preview exists and runs separately from it: the Android app is built from a copy,
 * the iPhone step is a home-screen shortcut, and publishing reuses the chat deployment flow.
 */
export default function ChatNextSteps({ projectId, previewUrl, target, targetPlatforms, onPublish, disabled }) {
  const [open, setOpen] = useState(null);
  const [copied, setCopied] = useState(false);
  if (!previewUrl) return null;
  let link = previewUrl;
  try { link = previewPageUrl(previewUrl, 'index.html'); } catch { /* keep the raw URL */ }
  link = withoutOwnerKey(link); // a shared/copied link never carries the owner key
  const toggle = key => setOpen(current => (current === key ? null : key));
  const copyLink = () => {
    if (!navigator.clipboard?.writeText) return;
    navigator.clipboard.writeText(link).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); }).catch(() => {});
  };
  return (
    <section className="chat-next-steps" dir="rtl" aria-label="השלבים הבאים">
      <strong className="chat-next-steps-title">{String(target || '').toUpperCase() === 'DESKTOP' ? 'מה עכשיו? התוכנה מוכנה ב־Preview — אפשר לארוז אותה למחשב' : 'מה עכשיו? האתר מוכן — אפשר להמשיך מכאן'}</strong>
      <div className="chat-next-steps-actions">
        {projectId && String(target || '').toUpperCase() === 'FULL_STACK' && <button type="button" className={`btn ${open === 'start' ? 'is-active' : ''}`} onClick={() => toggle('start')}>👥 התחלת עבודה עם המערכת</button>}
        {projectId && canPackageDesktop(target) && <button type="button" className={`btn ${open === 'desktop' ? 'is-active' : ''}`} onClick={() => toggle('desktop')}>🖥️ תוכנה למחשב</button>}
        {projectId && <button type="button" className={`btn ${open === 'android' ? 'is-active' : ''}`} onClick={() => toggle('android')}>📱 אפליקציית אנדרואיד</button>}
        <button type="button" className={`btn ${open === 'iphone' ? 'is-active' : ''}`} onClick={() => toggle('iphone')}>🍎 אייפון</button>
        <button type="button" className="btn" disabled={disabled} onClick={onPublish}>🚀 פרסום לחשבון שלי</button>
      </div>
      {open === 'start' && projectId && <AppStartPanel projectId={projectId} previewLink={link} />}
      {open === 'desktop' && projectId && <DesktopPackagePanel projectId={projectId} />}
      {open === 'android' && projectId && <AndroidPackagePanel projectId={projectId} target={target || 'WEB'} targetPlatforms={targetPlatforms || []} />}
      {open === 'iphone' && (
        <div className="chat-next-steps-panel">
          {projectId && <IosAppPanel projectId={projectId} />}
          <p>אפשר גם להוסיף את האתר למסך הבית של האייפון, והוא ייפתח כמו אפליקציה:</p>
          <ol>{iphoneHomeScreenSteps().map(step => <li key={step}>{step}</li>)}</ol>
          <button type="button" className="btn" onClick={copyLink}>{copied ? '✓ הקישור הועתק' : 'העתק קישור לאתר'}</button>
          <small>קישור התצוגה זמני. להוספה קבועה למסך הבית פרסמו קודם את האתר לחשבון שלכם והשתמשו בכתובת הקבועה.</small>
        </div>
      )}
    </section>
  );
}
